import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { PropertiesServices } from 'v2/resources/services/proporties';

import { IPropertie } from 'v2/resources/types/properties';

export const useProperties = (): UseQueryResult<Array<IPropertie>> => {
  const navigate = useHistory();

  const handleNavigate = () => {
    navigate.push('/first-property');
  };

  return useQuery({
    queryKey: ['getProperties'],
    queryFn: () => PropertiesServices.getProperties(),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    onSuccess(data) {
      if (data.length === 0) {
        handleNavigate();
      }
    },
  });
};
